<template>
  <div>
    <div class="filters">
      <v-menu v-model="menu" :close-on-click="false" :close-on-content-click="false" offset-x left>
        <template v-slot:activator="{ on, attrs }">
          <span
            class="filters-icon"
            v-bind="attrs"
            v-on="on"
            dark
          >
            <v-icon>
              {{ filterIcon(attrs) }}
            </v-icon>
          </span>
        </template>
        <div class="filters-fields">
          <h4>
            {{ $t('mapDrawing.pauseAppointmentOffer') }}
          </h4>

          <v-divider class="mb-2" />

          <v-select
            :label="$t('mapDrawing.timeInMinutes')"
            item-value="value"
            item-text="label"
            :items="timeOptions"
            v-model="time"
            class="filter-input"
            hide-details
            outlined
            dense
          />

          <v-btn
            color="primary"
            elevation="0"
            :disabled="!time"
            :loading="false"
            @click="pauseOffer"
          >
            {{ $t('mapDrawing.pause') }}
          </v-btn>
        </div>
      </v-menu>
    </div>
    <div class="timer">
      <v-menu v-if="activePause" v-model="resumeMenu" :close-on-click="false" :close-on-content-click="false" offset-x left>
        <template v-slot:activator="{ on, attrs }">
          <v-chip
            dark
            color="red"
          >
            {{ countdown }}
            <v-icon class="mr-0" x-small dark right v-bind="attrs" v-on="on">
              mdi-close
            </v-icon>
          </v-chip>
        </template>
        <div class="filters-fields">
          <span>
            {{ $t('mapDrawing.unpauseWarning') }}
          </span>

          <div class="d-flex">
            <v-btn outlined color="red" @click="resumeMenu = false">
              {{ $t('mapDrawing.cancel') }}
            </v-btn>
            <v-spacer />
            <v-btn color="primary" elevation="0" @click="resume()">
              {{ $t('mapDrawing.unpause') }}
            </v-btn>
          </div>
        </div>
      </v-menu>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MapPauseOffer',

  data() {
    return {
      time: null,
      menu: false,
      resumeMenu: false,
      targetDate: null,
      now: moment(),
      timeOptions: [
        { label: '5', value: 5 },
        { label: '10', value: 10 },
        { label: '15', value: 15 },
        { label: '20', value: 20 },
      ]
    }
  },

  computed: {
    ...mapGetters(['activePause']),

    countdown() {
      const timeDifference = moment(this.activePause.end_date).diff(this.now)

      if (timeDifference <= 0) {
        return "00:00";
      }

      const duration = moment.duration(timeDifference);

      const minutes = Math.floor(duration.minutes()).toString().padStart(2, '0');
      const seconds = duration.seconds().toString().padStart(2, '0');

      return `${minutes}:${seconds}`;
    },
  },

  methods: {
    ...mapActions(['fetchActiveAppointmentOfferPause', 'pauseAppointmentOffer', 'resumeAppointmentOffer']),

    filterIcon(attrs) {
      return attrs['aria-expanded'] === 'false' ? 'mdi-timer-pause-outline' : 'mdi-timer-pause'
    },

    startCountdown() {
      setInterval(() => {
        this.now = moment()
      }, 1000);
    },

    reset() {
      this.time = null
      this.menu = false
    },

    pauseOffer() {
      this.targetDate = moment().add(this.time, 'minutes')
      this.pauseAppointmentOffer({
        endDate: this.targetDate,
      })
      this.reset()
    },

    resume() {
      this.resumeAppointmentOffer()
      this.resumeMenu = false
    },
  },

  mounted() {
    this.fetchActiveAppointmentOfferPause()
    setInterval(() => {
      this.fetchActiveAppointmentOfferPause();
    }, 60 * 1000); // 1 minute
    this.startCountdown()
  },
}
</script>


<style scoped>
.filters {
  position: absolute;
  right: 5px;
  top: 5px;
}

.timer {
  position: absolute;
  right: 55px;
  top: 9px;
}

.filters-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 4px;
  background-color: white;
  box-shadow: -2px 6px 12px 0 rgba(0, 0, 0, 0.2) !important;
}

.filters-icon:hover i {
  color: #000 !important;
}

.filters-icon .v-icon {
  font-size: 22px;
}

.filters-fields {
  display: flex;
  flex-direction: column;
  width: 320px;
  gap: 15px;
  padding: 12px 10px;
  border-radius: 4px;
  background-color: white;
  overflow: hidden;
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.65);
  box-shadow: -2px 6px 12px 0 rgba(0, 0, 0, 0.2) !important;
}

.filter-input {
  font-size: 13px !important;
}

.filter-input i {
  font-size: 11px !important;
}

.v-menu__content {
  transform: translate(-5px, -6px);
}
</style>

